<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/f3dECO/tc-custom/9780544409644.jpg?1730584281643" alt="This image is the cover for the book How To Start A Fire"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">How To Start A Fire
      </h1>
      <p class="bookDescription body article font2">
        <b>From the bestselling author of <i>The Passenger</i>, a novel about three college women who are united by a single night that shaped all of them that will “keep you captivated from beginning to end” (<i>Town &amp; Country</i>) ¶ “Whip smart and cunning, deeply funny and profoundly moving . . . A knockout.”—Megan Abbott, author of <i>The Fever</i> ¶ </b>When college roommates Anna and Kate find Georgiana passed out on a lawn, they wheel her to their dorm in a shopping cart. Twenty years later, they gather around a campfire at a New England mansion. What came between—the wild adventures, unspoken jealousies, and one night that changed everything—is the witty, poignant story of our strongest friendships, the people who know us better than we know ourselves. Anna is the de facto leader, as fearless as she is reckless. Quirky Kate is the loyal sidekick, until she’s pushed too far. And stunning George is always desired, but just as frequently dumped. How to Start a Fire pulls us into the tangled bond shared by three intelligent, distinctive, and deeply real women and pays homage to the abiding, irrational love we have for the family we choose.<b> ¶“Lutz hits a home run in this glorious exploration of friendship.”—<i>Publishers Weekly</i> (starred review) ¶ “Excellent.”—<i>Chicago Tribune</i></b>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Lisa Lutz
      </h2>
      
      <p class="authorDescription body article"><P>LISA LUTZ&#160;is the <I>New York Times</I> best-selling author of the six novels in the Spellman Files series and <I>Heads You Lose</I> (with David Hayward). Lutz has won the Alex Award and has been nominated for the Edgar Award for Best Novel. She lives in upstate New York.</P><BR /></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Houghton Mifflin Harcourt (hmhbooks.com)
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?054db9c0